import {
    convertCategory,
    isHasProcedureBelongToCategory,
} from '../../modules/actions/categoryActions';
import { t } from '../../utils/i18n';
import { addonListeners } from '../../modules/events/addonListeners';
import { procedureListeners } from '../../modules/events/procedureListeners';
import { categories, isBookAppointment, surgicalOption, primaryColor, bodyAreaSelected, showBodyAreaSelection, isHideServiceDuration, form, scopeProceduresToSelectedLocation } from '../../utils/variables';
import { procedureDisplayName } from '../../utils/procedureDisplay';
import { loadAddons } from './addons';
import { loadProcedureInformation } from './procedureInfomation';

export function loadProcedures(procedures) {
    procedures = scopeProceduresToSelectedLocation(procedures);
    const procedureContainer = document.querySelector('.procedures__container');
    procedureContainer.innerHTML = '';
    let categoriesList = [];
    const listCategory = bodyAreaSelected?.map(item => item.name);

    categoriesList = categories.filter((i) => {
        if (showBodyAreaSelection && !listCategory.includes(i.name)) {
            return false;
        }
        return isHasProcedureBelongToCategory(i, procedures)
    }
    );

    if (categoriesList.length <= 0) {
        procedureContainer.insertAdjacentHTML(
            'beforeend',
            `
        <div class="noProcedures">${t('no_procedures_found')}</div>
        `
        );
        return;
    }

    /* Accordion mode: with more than one category the horizontal category
       carousel is hard to scan (chips overflow off-screen), so categories
       render as a collapsible menu instead — tap a category header to expand
       its services. Single-category channels keep the flat list.
       Sections start collapsed only when the menu is long (many services)
       AND there are 3+ categories; with just 2 categories (or a short menu)
       everything renders pre-expanded so visitors see it all at once. */
    const useAccordion = categoriesList.length > 1;
    const startCollapsed = useAccordion && categoriesList.length >= 3 && procedures.length > 8;
    procedureContainer.classList.toggle('procedure-accordion', useAccordion);

    /* Page-aware ordering: when the widget is embedded on a page about one
       specific service (a service page or a landing page), the API hoists that
       service — and its category — to the front of these lists. A collapsed
       section would hide the hoist completely, so the priority service's own
       section always renders expanded. Nothing is auto-selected: the visitor
       still sees every category and can pick anything. */
    /* variables.form holds the config PAYLOAD (loadData receives response.data),
       so priority_procedure_id lives at the top level — form.data is undefined
       here. Keep the .data fallback for any caller that stores the raw response
       (same pattern as disclaimerFooter.js). */
    const priorityProcedureId = form?.priority_procedure_id ?? form?.data?.priority_procedure_id ?? null;
    const priorityCategoryNames = priorityProcedureId
        ? (
            procedures.find((item) => Number(item.id) === Number(priorityProcedureId))
                ?.service_categories ?? []
        ).map((ca) => ca.name)
        : [];

    for (const i of categoriesList) {
        const collapseSection = startCollapsed && !priorityCategoryNames.includes(i.name);
        const sectionProcedureCount = procedures.filter((item) =>
            item.service_categories?.map((ca) => ca.name).includes(i.name)
        ).length;

        procedureContainer.insertAdjacentHTML(
            'beforeend',
            `
        <div id="${convertCategory(
                i.name
            )}" class="procedure-section__container${collapseSection ? ' procedure-section__collapsed' : ''}">
            <div class="category-section__wrapper${useAccordion ? ' category-section__wrapper--toggle' : ''}">
                ${i.icon ?
                `
                    <img loading="lazy" class="category__icon" src="${process.env.GOOGLE_CLOUD_ICON_URL
                }${i.icon}">
                    `
                : ''
            }
                <span class="category__text">${i.name}</span>
                ${useAccordion
                ? `<span class="category-section__toggle-right">
                        <span class="category__service-count">${sectionProcedureCount}</span>
                        <i class="ri-arrow-down-s-line category__chevron"></i>
                    </span>`
                : ''
            }
            </div>
        </div>
        `
        );

        let proceduresList = procedures.filter((item) => {
            return item.service_categories
                ?.map((ca) => ca.name)
                .includes(i.name);
        });

        /* NB: class list varies in accordion mode (adds
           procedure-section__collapsed), so match the class as a
           class selector — never as an exact class attribute. */
        const procedureSectionContainer = document.querySelector(
            `[id='${convertCategory(i.name)}'].procedure-section__container`
        );

        if (!useAccordion && categoriesList.indexOf(i) === categoriesList.length - 1) {
            /* fake-height only serves the carousel's scroll-jump targets —
               in accordion mode it would leave a giant empty area. */
            procedureSectionContainer.classList.add(
                'procedure-section__fake-height'
            );
        }

        if (proceduresList.length > 0) {
            procedureSectionContainer.insertAdjacentHTML(
                'beforeend',
                `
            <div class="procedures-list">${showListProcedure(
                    proceduresList,
                    i.name
                )}</div>
            `
            );
        } else {
            procedureSectionContainer.insertAdjacentHTML(
                'beforeend',
                `
            <div class="no-procedure-text">${t('no_procedures_found')}</div>
            `
            );
        }
    }
    if (useAccordion) {
        document
            .querySelectorAll('.category-section__wrapper--toggle')
            .forEach((header) => {
                header.addEventListener('click', function () {
                    this.closest('.procedure-section__container')?.classList.toggle(
                        'procedure-section__collapsed'
                    );
                });
            });
    }

    loadCheckBoxDetails(procedures);
    procedureListeners();
    addonListeners();

    document.querySelectorAll('.procedure__price').forEach(item => {
        item.style.backgroundColor = `${primaryColor}0f`;
    });
}

function showListProcedure(procedureList, category) {
    let listProcedures = ``;
    for (const procedure of procedureList) {
        const isHideServiceDurationOption =
            isHideServiceDuration ||
            procedure?.hide_duration_on_select_service ||
            form?.appointment_channel?.hide_duration_on_select_service;
        const price = procedure?.from || 0;
        const isShowFormText = (procedure.force_addon_selection === 1) ? true : false;
        const filterAddOns = procedure?.procedure_addons?.filter(item => !item?.deleted_at);
        const shouldShowPricing = (form?.appointment_channel?.show_pricing && procedure?.show_pricing) || (typeof surgicalOption === 'boolean' && !surgicalOption);

        let procedureWrapper = `
        <div class="procedure__content">
            <div class="line__wrapper procedure" data-procedure-id="${procedure.id}" data-category="${category}">
                <div class="procedure__checkbox" data-procedure-id="${procedure.id}" data-category="${category}">
                    <i class="procedure__icon-check ri-check-line"></i>
                </div>
                <div class="procedure__name--wrapper">
                    <div class="procedure__info-wrapper">
                        <div class="procedure__name-duration">
                            <div class="procedure__name">${procedureDisplayName(procedure)}</div>
                            <div class="procedure__price-duration ${(surgicalOption || isHideServiceDurationOption) ? 'hidden' : ''}">${procedureDuration(procedure.duration)}</div>
                        </div>
                        <div class="procedure__price--wrapper ${isBookAppointment && price !== 0 && shouldShowPricing ? '' : 'hidden'}">
                            ${isShowFormText ? `<span>${t('from')}</span>` : ''}
                            <div class="procedure__price">$${price.toLocaleString('en-US', { maximumFractionDigits: 2 })}</div>
                        </div> 
                    </div>
                    <div class="procedure__disableText"></div>
                </div>
                ${procedure.description
                ? `<span class="procedure__information procedure" data-procedure-id="${procedure.id}">
                        <i class="ri-question-line"></i>
                    </span>`
                : ""
            }
            </div>
            <div class="procedureBody__wrapper" data-procedure-id="${procedure.id
            }">
                ${loadProcedureInformation(procedure, category)}
            </div>
            <div class="addonsSections__wrapper addon__container" data-procedure-id="${procedure.id
            }" data-category="${category}">
                ${filterAddOns?.length > 0 ? loadAddons(procedure.id, category) : ''}
            </div>
        </div>
        `;

        listProcedures = listProcedures.concat(procedureWrapper);
    }

    return listProcedures;
}

function loadCheckBoxDetails(procedures) {
    let checkBox = document.querySelectorAll('.procedure__checkbox');
    checkBox.forEach(i => {
        const procedure = procedures.find(
            (p) => p.id === parseInt(i.getAttribute('data-procedure-id'))
        );
        const filterAddOns = procedure?.procedure_addons?.filter(item => !item.deleted_at);
        if (filterAddOns?.length > 0) {
            i.insertAdjacentHTML(
                'beforeend',
                `
            <span class="checkbox__count" data-procedure-id="${procedure.id}">0</span>
            <span class="checkbox__dots">...</span></div>
            `
            );
        }
    });
}

export function procedureDuration(durations) {
    if (!durations) return '';

    const durationTime = moment.duration(durations, 'm');
    if (durationTime.hours() === 1 && !durationTime.minutes()) {
        return `60min`;
    }
    return `${durationTime.hours() ? `${durationTime.hours()}h` : ''} ${durationTime.minutes()}min`;
}
